var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrabcad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 17,
    viewBox: "0 0 116 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15017 9.52426H12.9754V13.4076C11.4497 14.2468 9.72977 14.6718 7.98764 14.6401C5.00444 14.6368 2.53932 13.0564 2.53932 10.4326V5.96847C2.53932 3.43586 5.12634 1.9163 8.15356 1.9163C10.3275 1.90279 12.3219 2.50049 13.629 3.38859L14.4687 1.87915C12.9754 0.812081 10.5747 0.136719 8.05875 0.136719C3.97844 0.136719 0.507629 2.29788 0.507629 5.80639V10.6048C0.507629 14.1269 3.76849 16.4028 7.98764 16.4028C10.4583 16.4382 12.8889 15.7781 15.0004 14.4983V7.85274H8.15017V9.52426Z",
    fill: "#003393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3216 4.64419V5.20136C31.3216 7.38616 29.7064 8.68623 27.4918 9.12859L31.6433 16.1692H29.405L25.5109 9.57095H19.8087V16.1726H17.777V0.369141H25.9037C29.1781 0.369141 31.3216 1.94274 31.3216 4.64419ZM19.7816 2.13521V7.9028L25.9071 7.89943C27.5697 7.82851 29.2628 7.00795 29.2628 5.31954V4.73873C29.2628 3.18202 27.888 2.13521 25.7683 2.13521H19.7816Z",
    fill: "#003393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.272 16.1694L40.3322 0.183594H42.4959L49.4985 16.1694H47.2365L45.2048 11.5229H37.5826L35.5103 16.1694H33.272ZM41.4056 2.39879L38.0736 9.82778H44.7138L41.4056 2.39879Z",
    fill: "#003393"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1434 7.96697C62.8365 7.50097 63.9878 6.2009 63.9878 4.80627V4.38755C63.9878 1.82455 61.9121 0.369141 58.5327 0.369141H51.2626V16.1726H59.1151C62.4234 16.1726 64.5668 14.8016 64.5668 12.269V11.57C64.5702 9.75668 63.2157 8.52414 61.1434 7.96697ZM53.2909 2.04068H58.3025C60.7506 2.04068 61.9595 2.71604 61.9595 4.48211V4.90084C61.9595 6.41027 60.5373 7.26461 58.5733 7.26461H53.2909V2.04068ZM58.8849 14.4977C61.052 14.4977 62.5419 13.792 62.5419 12.1036V11.4316C62.5419 9.73644 60.8658 8.85171 58.6749 8.85171H53.2909V14.4977H58.8849Z",
    fill: "#003393"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9387 3.13533C76.5569 3.07759 78.1601 3.46298 79.5743 4.24968L80.8576 1.71707C79.1341 0.555443 77.4105 0.136719 74.7287 0.136719C70.7669 0.136719 67.3638 2.34515 67.3638 5.96847V10.5474C67.3638 14.4274 70.5096 16.4028 74.749 16.4028C77.4579 16.4028 79.0122 16.0077 80.6917 14.9609L79.5269 12.3574C78.3146 13.0767 76.7299 13.4042 74.959 13.4042C72.6327 13.4076 70.9396 12.5229 70.9396 10.3381V6.1542C70.9396 4.18889 72.7952 3.13533 74.9387 3.13533Z",
    fill: "#003393"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9039 16.1724L88.3376 0.230469H92.2723L98.6586 16.1724H94.7205L93.3932 12.7112H87.1931L85.8386 16.1724H81.9039ZM90.3185 3.74915L87.8704 10.0233H92.7193L90.3185 3.74915Z",
    fill: "#003393"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.653 0.369141H108.103C112.295 0.369141 115.278 2.27366 115.298 6.41701V10.1315C115.298 14.2884 111.997 16.1726 107.849 16.1726H100.653V0.369141ZM107.845 13.2618C109.941 13.2618 111.76 12.2184 111.76 9.54736L111.756 6.98773C111.756 4.41122 110.151 3.27324 108.099 3.27324H104.161V13.2618H107.845Z",
    fill: "#003393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrabcad);
export default __webpack_public_path__ + "static/media/grabcad.57b2650ebf0098eab5a4ee253d4f0247.svg";
export { ForwardRef as ReactComponent };